import React from 'react';
import PropTypes from 'prop-types';
const Moment = require('moment');

const uuid = require('uuid');

const _ = {
    find:       require('lodash/find'),
    forEach:    require('lodash/forEach'),
    map:        require('lodash/map'),
    omit:       require('lodash/omit'),
};

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const StringUtil = require('../../../../app/shared/StringUtil');

const GlobalUserStore = require('../../stores/GlobalUserStore');
const GlobalUserActions = require('../../actions/GlobalUserActions');
const ProjectStore = require('../../stores/ProjectStore');
const ChannelStore = require('../../stores/channel_store_reflux');

import SortableTableClassic from '../table/SortableTableClassic';

const propTypes = {
    className: PropTypes.string,
    userInfo: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        display_name: PropTypes.string.isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired,
};
const defaultProps = {
    className: '',
};

const HISTORY_DATE_FORMAT = 'MM/DD/YYYY HH:mm zz';

const LMS_DEPLOYMENT_SETTING_NAMES = {
    op_id: 'OpenID Provider ID',
    platform_url: 'Platform URL',
    aud: 'Client ID',
    deployment_id: 'Deployment ID',
    oidc_auth_url: 'OIDC Auth URL',
    access_token_url: 'Access Token URL',
    jwks_url: 'JWKS URL',
    tag_prefix: 'Tag Prefix',
    fix_default_lineitem_tag_collision: 'Auto-correct tag collisions',
    ensure_grade_lineitem: "Ensure 'grade' lineitem",
};

const LMS_DEPLOYMENT_ON_OFF_SETTINGS = ['fix_default_lineitem_tag_collision', 'ensure_grade_lineitem']; // missing means off

// "Client ID: old → new; Tag Prefix: (blank) → x_" for the settings that differ
const describeLmsDeploymentChanges = (before = {}, after = {}) => {
    const flatten = (s = {}) => ({ ..._.omit(s, ['options']), ...(s.options || {}) });
    const b = flatten(before);
    const a = flatten(after);
    const show = (v, k) => {
        if (LMS_DEPLOYMENT_ON_OFF_SETTINGS.includes(k) || typeof v === 'boolean') return v ? 'on' : 'off';
        return (v === undefined || v === null || v === '') ? '(blank)' : String(v);
    };
    const keys = Object.keys({ ...b, ...a }).filter(k => show(b[k], k) !== show(a[k], k));
    return keys.map(k => `${LMS_DEPLOYMENT_SETTING_NAMES[k] || k}: ${show(b[k], k)} → ${show(a[k], k)}`).join('; ');
};

const ACTION_HISTORY_COLUMNS = [
    {displayName: 'Date',   key: 'performed_at', size: 2, type: 'date' },
    {displayName: 'Action', key: 'actionName',   size: 5, type: 'string' }, 
];

class ActionHistoryPanel extends React.Component {
    constructor(props) {
        super(props);
        
        const actionHistory = this.getActionHistory(props,GlobalUserStore.getState());
        const dayRange = Globals.user_actions.day_ranges.LAST_7_DAYS;
        let historyActionId = null;
        if (!actionHistory || (actionHistory.dayRange !== dayRange) ) {
            historyActionId = uuid.v4();
            GlobalUserActions.getActionHistory(historyActionId,{userId: props.userInfo.id, dayRange});
        }
        
        let projects = null;
        let channels = null;
        let organizations = null;
        const projectStoreState = ProjectStore.getState();
        const channelStoreState = ChannelStore.getState();
        
        this.state = {
            dayRange,actionHistory,historyActionId,
            projectStoreState, channelStoreState,
            calculatedRowHeight: 50,
        };
        
        this.unsubscribes = [
            GlobalUserStore.listen(this.onUserStoreChange),
            ProjectStore.listen(this.onProjectStoreChange),
            ChannelStore.listen(this.onChannelStoreChange),
        ];
    }

    componentDidMount() {
        setTimeout(()=>{ this.measureRowHeight() },10);
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
        delete this.unsubscribes; // tell ourselves that this component is no longer mounted
    }

    getActionHistory=(props,storeState)=>{
        const userId = props.userInfo.id;
        return storeState.userActionHistory[userId];
    }
    
    onUserStoreChange=(storeState)=>{
        let actionHistory = this.getActionHistory(this.props,storeState);
        let changes = { actionHistory };
        if (storeState.action.id === this.state.historyActionId) {
            changes.historyActionId = null;
        }
        this.setState(changes,()=>{
            setTimeout(()=>{ this.measureRowHeight() },10);
        });
    }
    
    measureRowHeight=()=>{
        if (this.unsubscribes) {
            let t = $(".action-history-table");
            let calculatedRowHeight = 50; // minimum
            const extra = 15; // margin between rows?
            if (t) {
                let f = $(t).find(".trad-link");
                f.each(function( /*index*/ ) {
                    let e = $(this);
                    let h = e.height();
                    if ((h>0) && (h < 200)) {
                        calculatedRowHeight = Math.max(calculatedRowHeight,h+extra);
                    }
                    //else {
                    //    console.log("unexpected row height:",h);
                    //}
                });
            }
            this.setState({calculatedRowHeight});
        }
        
    }
    
    onProjectStoreChange=()=>{
        const projectStoreState = ProjectStore.getState();
        this.setState({projectStoreState});
    }
    
    onChannelStoreChange=()=>{
        const channelStoreState = ChannelStore.getState();
        this.setState({channelStoreState});
    }
    
    onSelectDayRange=(e)=>{
        let dayRange = e.target.value;
        let {actionHistory, historyActionId} = this.state;
        if (historyActionId) {
            console.log("busy... cannot select day range yet"); // should be disabled
            return;
        }
        if (!actionHistory || (actionHistory.dayRange !== dayRange) ) {
            historyActionId = uuid.v4();
        }
        this.setState({dayRange,historyActionId},()=>{
            if (historyActionId) {
                GlobalUserActions.getActionHistory(historyActionId,{userId: this.props.userInfo.id, dayRange});
            }
        });
    }
    
    // onActionHistoryRowClick=(e, row_id, something)=>{
    //     console.log(`onActionHistoryRowClick(e,${row_id},${something})`);
    // }
    
    getActionName=(row)=>{
        let details = '';
        let actionName = Strings['en'].analytics.user_actions[row.action_type] || row.action_type; // use nice name if possible

        let channel_id = row.data.channel_id || row.data.owner_id;
        let { project_id } = row.data;
        let projectName, channelName;
        
        if (project_id && this.state.projectStoreState.initialized) {
            let project = _.find(this.state.projectStoreState.projects,{id: project_id});
            if (!project) {
                project = _.find(this.state.projectStoreState.shortCourseProjects,{id: project_id});
            }
            projectName = project ? project.name : "Project";
            
        }
        if (channel_id && this.state.channelStoreState.initialized) {
            let channel = _.find(this.state.channelStoreState.channels, {id: channel_id});
            if (!channel) {
                channel = _.find(this.state.channelStoreState.organizations,{id: channel_id});
            }
            channelName = channel ? channel.name : "Channel";
        }

        if (projectName || channelName) {
            actionName += ': ';
        }

        switch(row.action_type) {
            case Globals.user_actions.type.PROJECT_ADDED_AS_COLLABORATOR:
            case Globals.user_actions.type.PROJECT_REMOVED_AS_COLLABORATOR:
            case Globals.user_actions.type.PROJECT_ROLE_CHANGED:
                break;
                
            default: {
                if (channelName) {
                    actionName += (channelName + "→");
                }
                if (projectName) {
                    actionName += (projectName + "→");
                }
            }
        }

        // add more details depending on action type
        switch(row.action_type) {
            case Globals.user_actions.type.COURSE_CREATE:
            case Globals.user_actions.type.COURSE_EDIT:
            case Globals.user_actions.type.COURSE_SAVE:
                actionName += `${row.data.course_name}`;
                break;
                
            case Globals.user_actions.type.COURSE_RENAME:
                actionName += `: ${row.data.course_name} to ${row.data.new_course_name}`;
                break;

            case Globals.user_actions.type.ACTIVITY_CREATE:
            case Globals.user_actions.type.ACTIVITY_EDIT:
            case Globals.user_actions.type.ACTIVITY_SAVE:
            case Globals.user_actions.type.ACTIVITY_PUBLISH:
            case Globals.user_actions.type.ACTIVITY_UNPUBLISH:
            case Globals.user_actions.type.ACTIVITY_DELETE:
            case Globals.user_actions.type.ACTIVITY_MOVE:
                actionName += `${row.data.activity_name}`;
                if (row.data.versions) {
                    details += `versions: ${row.data.versions.join(',')}`;
                }
                break;

            case Globals.user_actions.type.ACTIVITY_ATTACH_I_TAG:
                actionName += `${row.data.activity_name} ${row.data.tags}`;
                break;

            case Globals.user_actions.type.ACTIVITY_REMOVE_I_TAG:
                actionName += `${row.data.activity_name} ${row.data.tag}`;
                break;

            case Globals.user_actions.type.ACTIVITY_ATTACH_M_TAG:
                actionName += `${row.data.activity_name} ${row.data.tag_name}`;
                break;

            case Globals.user_actions.type.ACTIVITY_REMOVE_M_TAG:
                actionName += `${row.data.activity_name} ${row.data.tag_name}`;
                break;

            case Globals.user_actions.type.ACTIVITY_RENAME:
                actionName += `: ${row.data.activity_name} to ${row.data.new_activity_name}`;
                break;

            case Globals.user_actions.type.ACTIVITY_UPDATE_DISPLAY_NAME:
                actionName = `set display name for ${row.data.activity_name} to ${row.data.display_name}`;
                break;

            case Globals.user_actions.type.ACTIVITY_UPDATE_IMAGE:
                actionName = `set image for ${row.data.activity_name}`;
                break;

            case Globals.user_actions.type.ACTIVITY_UPDATE_DESCRIPTION:
                actionName = `set description for ${row.data.activity_name} to ${row.data.description}`;
                break;

            case Globals.user_actions.type.ACTIVITY_UPDATE_COURSE_METADATA:
                actionName = `update course meta data for ${row.data.activity_name}`;
                break;

            case Globals.user_actions.type.ACTIVITY_COPY:
                actionName += `: ${row.data.activity_name} to ${row.data.dest_activity_name}`;
                break;
                
            case Globals.user_actions.type.ORG_ADDED_TO:
                actionName = `Added to ${row.data.organization_name}`;
                break;

            case Globals.user_actions.type.ORG_REMOVED_FROM:
                actionName = `Removed from ${row.data.organization_name}`;
                break;
                
            case Globals.user_actions.type.ORG_ROLE_CHANGED:
                actionName = `Role changed to ${StringUtil.getStringForRoleToken(row.data.role)} in organization ${row.data.organization_name}`;
                break;

            case Globals.user_actions.type.ORG_EDIT_LMS_DEPLOYMENT: {
                const provider = row.data.provider_description || row.data.issuer || 'LMS';
                actionName = `Edited ${provider} LTI 1.3 deployment in organization ${row.data.organization_name}`;
                details = describeLmsDeploymentChanges(row.data.before, row.data.after);
                break;
            }

            case Globals.user_actions.type.ADMIN_EDIT_LMS_DEPLOYMENT: {
                const provider = row.data.provider_description || row.data.issuer || 'LMS';
                actionName = `Admin edited ${provider} LTI 1.3 deployment for ${row.data.account_name} (account ${row.data.account_id})`;
                details = describeLmsDeploymentChanges(row.data.before, row.data.after);
                break;
            }

            case Globals.user_actions.type.ADMIN_ADD_LMS_DEPLOYMENT:
            case Globals.user_actions.type.ADMIN_ARCHIVE_LMS_DEPLOYMENT:
            case Globals.user_actions.type.ADMIN_UNARCHIVE_LMS_DEPLOYMENT: {
                const provider = row.data.provider_description || row.data.issuer || 'LMS';
                const verb = {
                    [Globals.user_actions.type.ADMIN_ADD_LMS_DEPLOYMENT]: 'added',
                    [Globals.user_actions.type.ADMIN_ARCHIVE_LMS_DEPLOYMENT]: 'archived',
                    [Globals.user_actions.type.ADMIN_UNARCHIVE_LMS_DEPLOYMENT]: 'unarchived',
                }[row.action_type];
                actionName = `Admin ${verb} ${provider} LTI 1.3 deployment for ${row.data.account_name} (account ${row.data.account_id})`;
                const deploymentId = row.data.settings && row.data.settings.deployment_id;
                details = `Record #${row.data.deployment_record_id}; Deployment ID: ${deploymentId || '(blank)'}`;
                break;
            }

            case Globals.user_actions.type.PROJECT_ADDED_AS_COLLABORATOR:
                actionName = `Added to project ${row.data.project_name}`;
                break;

            case Globals.user_actions.type.PROJECT_REMOVED_AS_COLLABORATOR:
                actionName = `Removed from project ${row.data.project_name}`;
                break;

            case Globals.user_actions.type.PROJECT_ROLE_CHANGED:
                actionName = `Role changed to ${StringUtil.getStringForRoleToken(row.data.roleToken)} in project ${row.data.project_name}`;
                break;
                
            case Globals.user_actions.type.ASSN_CREATE:
                actionName = `Create Assignment: ${row.data.assignmentName}`;
                break;

        }
        
        return {actionName,details};
    }

    getActionLink=(row)=>{ // 'external' property denotes whether link should navigate without using app router
        if (!row || !row.data) {
            return;
        }

        switch (row.action_type) {
            case Globals.user_actions.type.COURSE_CREATE:
            case Globals.user_actions.type.COURSE_EDIT:
            case Globals.user_actions.type.COURSE_SAVE:
            case Globals.user_actions.type.COURSE_RENAME:
            case Globals.user_actions.type.COURSE_PUBLISH:
            {
                let { project_id, channel_id, course_id } = row.data;
                if (project_id && channel_id && course_id) {
                    return {
                        external: false,
                        url: `/project/${channel_id}/${project_id}/short_course/${course_id}`,
                    };
                }
                break;
            }
            case Globals.user_actions.type.COURSE_INST_CREATE_LOCAL:
            case Globals.user_actions.type.COURSE_INST_START_ATTEMPT:
            case Globals.user_actions.type.COURSE_INST_COMPLETE_ATTEMPT:
            {
                if (row.data.inst_hash) {
                    return {
                        external: true,
                        url: `/course_instance/${row.data.inst_hash}`,
                    };
                }
                break;
            }
            
            case Globals.user_actions.type.ACTIVITY_CREATE:
            {
                let ch = row.data.owner_id || row.data.channel_id;
                if (ch && row.data.project_id && row.data.activity_id) {
                    return {
                        external: false,
                        url:`/project/${ch}/${row.data.project_id}/activity/${row.data.activity_id}`,
                    };
                }
                break;
            }

            case Globals.user_actions.type.ACTIVITY_EDIT:
            case Globals.user_actions.type.ACTIVITY_SAVE:
            case Globals.user_actions.type.ACTIVITY_PUBLISH:
            case Globals.user_actions.type.ACTIVITY_UNPUBLISH:
            case Globals.user_actions.type.ACTIVITY_RENAME:
            case Globals.user_actions.type.ACTIVITY_DELETE:
            case Globals.user_actions.type.ACTIVITY_ATTACH_I_TAG:
            case Globals.user_actions.type.ACTIVITY_REMOVE_I_TAG:
            case Globals.user_actions.type.ACTIVITY_ATTACH_M_TAG:
            case Globals.user_actions.type.ACTIVITY_REMOVE_M_TAG:
            case Globals.user_actions.type.ACTIVITY_UPDATE_DISPLAY_NAME:
            case Globals.user_actions.type.ACTIVITY_UPDATE_IMAGE:
            case Globals.user_actions.type.ACTIVITY_UPDATE_DESCRIPTION:
            case Globals.user_actions.type.ACTIVITY_UPDATE_COURSE_METADATA:
            {
                if (row.data.channel_id && row.data.project_id && row.data.activity_id) {
                    return {
                        external: false,
                        url:`/project/${row.data.channel_id}/${row.data.project_id}/activity/${row.data.activity_id}`,
                    };
                }
                break;
            }

            case Globals.user_actions.type.ACTIVITY_MOVE:
            case Globals.user_actions.type.ACTIVITY_COPY:
            {
                if (row.data.channel_id && row.data.source_project_id && row.data.activity_id) {
                    return {
                        external: false,
                        url:`/project/${row.data.channel_id}/${row.data.source_project_id}/activity/${row.data.activity_id}`,
                    };
                }
                break;
            }

            case Globals.user_actions.type.USER_LOGIN:
                return; // no link
         
             case Globals.user_actions.type.ASSN_CREATE:
                switch(row.data.integrationType) {
                    case Globals.integration_type.LOCAL:
                        return {
                            external: true,
                            url: `/assignment/${row.data.assignmentHash}/mzl_instructor`,
                        };
                }
        }

        // console.debug("unable to determine link for action row", row);
        return null;
    }

    render() {
        if (!this.state.actionHistory) {
            return null;
        }

        let tableTitle;
        switch (this.state.actionHistory.dayRange) {
            case Globals.user_actions.day_ranges.LAST_7_DAYS: {
                tableTitle = Strings['en'].analytics.action_history.ACTIONS_LAST_7_DAYS;
                break;
            }
            case Globals.user_actions.day_ranges.LAST_30_DAYS: {
                tableTitle = Strings['en'].analytics.action_history.ACTIONS_LAST_30_DAYS;
                break;
            }
            case Globals.user_actions.day_ranges.LAST_60_DAYS: {
                tableTitle = Strings['en'].analytics.action_history.ACTIONS_LAST_60_DAYS;
                break;
            }
            case Globals.user_actions.day_ranges.LAST_90_DAYS: {
                tableTitle = Strings['en'].analytics.action_history.ACTIONS_LAST_90_DAYS;
                break;
            }
            case Globals.user_actions.day_ranges.ALL: {
                tableTitle = Strings['en'].analytics.action_history.ACTIONS_ALL;
                break;
            }
            default: {
                tableTitle = Strings['en'].analytics.action_history.ACTION_HISTORY;
                break;
            }
        }

        let actionHistoryRows = _.map(this.state.actionHistory.action_history,(entry,i)=>{
            let {actionName,details} = this.getActionName(entry);
            return {
                ...entry, 
                index: i,
                actionName,details,
            };
        });
        
        return (
            <div className={`action-history ${this.props.className}`}>
                <div className="margin-bottom-md">
                    <h2 className="section-title inline-block">{Strings['en'].dashboard.HISTORY}</h2>
                    <select value={this.state.dayRange} onChange={this.onSelectDayRange} disabled={this.state.historyActionId} className="fr">
                        {_.map(Globals.user_actions.day_ranges,(v,k)=>(
                        <option key={k} value={v}>{Strings['en'].analytics.day_ranges[k]}</option>
                        ))}
                    </select>
                    <div className="float-clear" />
                </div>
                <SortableTableClassic
                    classNameTableContainer="action-history-table"
                    variant="new"
                    title={tableTitle}
                    titleSize="sm"
                    rows={actionHistoryRows}
                    rowHeight={this.state.calculatedRowHeight}
                    hideTotal
                    hideFilter
                    uniqueRowKey="id"
                    selectedRowKey={this.state.selectedActionHistoryElement}
                    columns={ACTION_HISTORY_COLUMNS}
                    defaultSort={{ key:'performed_at', type:'date', asc: false }}
                    dateFormat={HISTORY_DATE_FORMAT}
                    displayColumnCallbacksRow={{
                        actionName: (row) => {
                            let actionLinkObj = this.getActionLink(row);
                            let elem;
                            if (actionLinkObj) {
                                if (!actionLinkObj.external) {
                                    elem = (
                                        <a className="trad-link" onClick={()=>{this.props.history.push(actionLinkObj.url)}}>
                                            {row.actionName}
                                        </a>
                                    );
                                }
                                else {
                                    elem = (
                                        <a className="trad-link" href={actionLinkObj.url}>
                                            {row.actionName}
                                        </a>
                                    );
                                }

                            }
                            else {
                                elem = (<span>{row.actionName}</span>);
                            }
                            if (row.details) {
                                return(
                                    <span>
                                        {elem}
                                        <span className="action-details">{row.details}</span>
                                    </span>
                                );
                            }
                            return elem;
                        },
                    }}
                />
            </div>
        );
    }
} // ActionHistoryPanel

ActionHistoryPanel.propTypes = propTypes;
ActionHistoryPanel.defaultProps = defaultProps;

export default ActionHistoryPanel;
